import { SpreadsheetUtils } from 'basic-components';
import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_CSV_EDITOR'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const setEmptyTable = (setColumns, setData) => {
    const columns = Array(8).fill({}).map((c, index) => ({ columnName: `Column${index + 1}` }))
    const data = Array(8).fill({}).map(() => {
      const object = {}
      columns.forEach(c => {
        object[c.name] = ""
      })
      return object;
    })
    setColumns(SpreadsheetUtils.getDecoratedSpreadsheetColumns(columns))
    setData(data)
  }

  return {
    changeValue,
    CHANGE_VALUE,
    setEmptyTable
  }
})()